import { useEffect } from 'react';

export const useOptimizeExperiment = (experimentId: string, callback: Function) => {
  useEffect(() => {
    window.gtag('event', 'optimize.callback', {
      name: experimentId,
      callback,
    });
  }, []);
};
